import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import ClosingCodesService from '../../components/services/ClosingCodesService';

const useClosingCodesService = () => {
  return useMemo(() => new ClosingCodesService(new ApiCalls()), []);
};

export default useClosingCodesService;
